module.exports = __webpack_public_path__ + "img/IconDietConsultation.f6a224a4.svg";